var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobileDebatesSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18325 18.7442C1.7234 21.4233 4.55915 23.5814 5.90951 24.3256C5.68447 22.8372 4.47086 20.4186 5.23433 17.6279C5.71092 15.8859 7.48495 13.907 8.61029 13.1628C8.61029 14.8372 9.07196 16.5403 9.28547 17.0698C9.96065 18.7442 11.9862 20.9768 11.9862 20.9768C12.573 20.4186 13.835 19.8604 15.2737 18.7442C15.2737 18.7442 15.4504 19.8605 14.6869 21.5349C13.9234 23.2093 12.6614 24.8837 11.9862 26C13.3366 25.4419 20 23.2093 20 16.5116C20 12.6046 18.6496 11.4884 16.6241 9.25581C16.6241 10.3721 16.895 12.3708 16.6241 13.1628C15.8606 15.3953 14.6869 15.9535 13.2482 16.5116C14.5102 13.1628 14.5986 10.3721 13.2482 7.5814C11.9862 4.97329 8.61029 3.11628 7.25993 2C7.25993 3.11625 5.34917 7.11544 3.79566 9.25581C1.77013 12.0465 0.508072 15.3953 1.18325 18.7442Z",
    fill: "#F31C4B",
    stroke: "#F31C4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileDebatesSelected);
export default __webpack_public_path__ + "static/media/icon-mobile-debates-selected.6cfd410264e99b35e8cc4e3ed96d1812.svg";
export { ForwardRef as ReactComponent };